// state <- 値の格納のみ
export const state = {
    // GmoInput コンポーネントでの入力値
	'creditCno': '',
	'creditSno': '',
	'creditLimitYear': new Date().getFullYear(),
	'creditLimitMonth': new Date().getMonth()+1,
};

export const mutations = {
	setCreditCno(state, param) {
		state.creditCno = param;
	},
	setCreditSno(state, param) {
		state.creditSno = param;
	},
	setCreditLimitYear(state, param) {
		state.creditLimitYear = param;
	},
	setCreditLimitMonth(state, param) {
		state.creditLimitMonth = param;
	},
};

export const getters = {
	getCreditCno: (state) => { return state.creditCno; },
	getCreditSno: (state) => { return state.creditSno; },
	getCreditLimitYear: (state) => { return state.creditLimitYear; },
	getCreditLimitMonth: (state) => { return state.creditLimitMonth; },
};

export default {
	namespaced: true,
	state,
	getters,
	mutations
}
